import { useEffect, useState, useMemo } from 'react';

import { CircularProgress, Typography } from '@mui/material';

import { fetchCandidates } from 'api';
import { CandidateProps, TrancheProps } from 'types';

export const DerogCell = (props: TrancheProps) => {
  const { candidate_count, id } = props;

  const [loading, setLoading] = useState(false);

  const [candidatesWithEmployerDerog, setCandidatesWithEmployerDerog] =
    useState<Array<CandidateProps>>([]);
  const [candidatesWithDerogs, setCandidatesWithDerogs] = useState<
    Array<CandidateProps>
  >([]);
  const candidateCount = useMemo(() => {
    return candidate_count || 0;
  }, [candidate_count]);
  useEffect(() => {
    const fetchCandidatesWithEmployerDerog = async () => {
      try {
        setLoading(true);
        const { data } = await fetchCandidates({
          params: {
            tranche_id: id,
            has_derogs: true,
          },
        });
        setCandidatesWithEmployerDerog(data);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    const fetchCandidatesWithDerog = async () => {
      try {
        setLoading(true);
        const { data } = await fetchCandidates({
          params: {
            tranche_id: id,
            flag_types_include: 'derog_flag',
          },
        });
        setCandidatesWithDerogs(data);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };

    if (candidateCount > 0) {
      fetchCandidatesWithDerog(); // All derogs type
      fetchCandidatesWithEmployerDerog(); //Only derogs from employer
    }

    return () => {
      setCandidatesWithDerogs([]);
      setCandidatesWithEmployerDerog([]);
    };
  }, [
    setLoading,
    id,
    setCandidatesWithDerogs,
    setCandidatesWithEmployerDerog,
    candidateCount,
  ]);
  if (loading) {
    return <CircularProgress size={30} />;
  }
  const candidates = candidatesWithDerogs.concat(candidatesWithEmployerDerog);
  const uniqueCandidates = candidates.filter((obj, index) => {
    return (
      index === candidates.findIndex((o) => obj.case_number === o.case_number)
    );
  });
  const uniqueCandidateCount = uniqueCandidates.length;

  return (
    <Typography variant='body1'>
      {uniqueCandidateCount === null
        ? '0'
        : `${candidateCount - uniqueCandidateCount} | ${uniqueCandidateCount}`}
    </Typography>
  );
};
